module.exports = __webpack_public_path__ + "img/20220228113500157hke.cbca3476.png";